import { VNode, h } from "preact";
import { UIFormProps } from "./FormProvider.js";
import { InputLine } from "./InputLine.js";

export function InputText<T extends object, K extends keyof T>(
  props: UIFormProps<T, K>,
): VNode {
  return <InputLine type="text" {...props} />;
}
